import { forwardRef } from 'react'
import { AdminIcon } from './AdminIcon'
import styles from './AdminButton.module.css'

/**
 * Admin button with variants: primary, secondary, quiet, icon-only.
 * All buttons have 44px minimum touch target on mobile.
 */
export const AdminButton = forwardRef(function AdminButton(
  { variant = 'secondary', icon, label, children, className = '', disabled, ...rest },
  ref
) {
  const isIconOnly = variant === 'icon-only'
  const variantClass = styles[variant] || styles.secondary

  return (
    <button
      ref={ref}
      className={`${styles.button} ${variantClass} ${className}`}
      disabled={disabled}
      type="button"
      aria-label={isIconOnly ? label : undefined}
      title={isIconOnly ? label : undefined}
      {...rest}
    >
      {icon && <AdminIcon name={icon} size={isIconOnly ? 18 : 16} />}
      {!isIconOnly && children}
    </button>
  )
})
